var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({class:[
    'hover:text-primary cursor-pointer font-semibold',
    _vm.small ? 'text-sm' : 'text-lg',
    _vm.active ? 'text-primary' : 'text-dark-l-5'
  ]},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }